module.exports = __webpack_public_path__ + "media/images/undraw_co_workers-84d567188d5efe9a46a4e102972173c8.svg";